import { render, staticRenderFns } from "./PointExchange.vue?vue&type=template&id=489453d3&scoped=true&"
import script from "./PointExchange.vue?vue&type=script&lang=js&"
export * from "./PointExchange.vue?vue&type=script&lang=js&"
import style0 from "./PointExchange.vue?vue&type=style&index=0&id=489453d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489453d3",
  null
  
)

export default component.exports